import React, { Component } from 'react';
import './index.less';
import classnames from 'classnames';
import { ABSButton } from '../ABSButton';
import ABSSubTitle from '../ABSSubTitle';

interface IABSSubTitleContainerProps {
  className?: string;
  title: string;
  renderLeft?: React.ReactNode | null;
  renderRight?: React.ReactNode | null;
  buttonIcon?: string;
  buttonType?: 'primary' | 'default' | 'danger';
  buttonTitle?: string;
  buttonClick?: React.MouseEventHandler<HTMLButtonElement>; // 改为 onClick
  removePadding?: 'top' | 'bottom' | 'both';
}

class ABSSubTitleContainer extends Component<IABSSubTitleContainerProps> {

  renderRight() {
    const { renderRight, buttonIcon, buttonType, buttonTitle, buttonClick } = this.props;
    if (renderRight || renderRight === null) {
      return renderRight;
    }
    return (
      <ABSButton icon={buttonIcon} type={buttonType} onClick={buttonClick}>{buttonTitle}</ABSButton>
    );
  }
  renderLeft() {
    const { renderLeft } = this.props;
    if (renderLeft || renderLeft === null) {
      return renderLeft;
    }
    return null;
  }

  render() {
    const { className, title, removePadding } = this.props;
    const clazs = classnames('abs-sub-title-container', 
    { 'abs-sub-title-no-top' : removePadding === 'top' || removePadding === 'both'}, 
    { 'abs-sub-title-no-bottom' : removePadding === 'bottom' || removePadding ===  'both'}, 
    className);
    return (
      <div className={clazs}>
        <div className="left-wrapper">
          <ABSSubTitle title={title} />
          {this.renderLeft()}
        </div>

        {this.renderRight()}
      </div>
    );
  }
}

export default ABSSubTitleContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSubTitleContainer/index.tsx